import { render, staticRenderFns } from "./HowToUsePopup.vue?vue&type=template&id=5b501fc6&scoped=true&"
import script from "./HowToUsePopup.vue?vue&type=script&lang=js&"
export * from "./HowToUsePopup.vue?vue&type=script&lang=js&"
import style0 from "./HowToUsePopup.vue?vue&type=style&index=0&id=5b501fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b501fc6",
  null
  
)

export default component.exports